import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * A wrapper for routes that require authentication and specific permissions.
 * 
 * @param {Object} props
 * @param {string} props.resource - The resource being accessed (e.g., 'members', 'payments')
 * @param {string} props.action - The action being performed (e.g., 'view', 'create', 'update', 'delete')
 * @param {string} props.redirectTo - Where to redirect if not authenticated or authorized
 */
const ProtectedRoute = ({ 
  resource = null,
  action = 'view',
  redirectTo = '/login'
}) => {
  const { currentUser, loading, hasPermission } = useAuth();
  
  // Show loading state
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  
  // Check if user is authenticated
  if (!currentUser) {
    return <Navigate to={redirectTo} />;
  }
  
  // Check if user has permission for the resource and action
  if (resource && !hasPermission(resource, action)) {
    return <Navigate to="/unauthorized" />;
  }
  
  // Render the child routes
  return <Outlet />;
};

export default ProtectedRoute;
